import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => state[NAME];

export const getPowerStationsModel = createSelector(
    getModel,
    (model) => model.powerStations,
);

export const getPowerStations = createSelector(
    getPowerStationsModel,
    (model) => model.data,
);

export const getPowerStationsData = createSelector(
    getPowerStations,
    (stations) => stations.data || [],
);

export const getPowerStationsPagination = createSelector(
    getPowerStations,
    (stations) => stations.pagination,
);

export const getPowerStationsColumns = createSelector(
    getPowerStations,
    (stations) => stations.columns || [],
);

export const getPowerStationsIsFetching = createSelector(
    getPowerStationsModel,
    (model) => model.isFetching,
);
